import Vue from 'vue'
import VueRouter from 'vue-router'
import Authorization from '../views/Authorization.vue'
import MapView from '../views/MapView.vue'

Vue.use(VueRouter);

  const routes = [
  {
    path: '/',
    name: 'authorization',
    component: Authorization
  },
  {
    path: '/map',
    name: 'map',
    component: MapView
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
